import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs-compat/operator/map';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { ProductDownloadService } from 'src/app/core/services/product-download.service';
import { ReportsService } from 'src/app/core/services/reports.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { ArchiviedDocumentInfo } from 'src/app/model/ArchiviedDocumentInfo';
import { ProjectDataType } from 'src/app/model/customer';
import { ProductDto } from 'src/app/model/ProductDto';
import { ProjectImprovementReleases } from 'src/app/model/ProjectImprovementReleases';

@Component({
  selector: 'ms-product-improvement-details',
  templateUrl: './product-improvement-details.component.html',
  styleUrls: ['./product-improvement-details.component.scss']
})
export class ProductImprovementDetailsComponent implements OnInit {
  improvement: ProjectImprovementReleases;
  productDto: ProductDto;
  archiviedDocuments: ArchiviedDocumentInfo[] = [];
  localizedFields: Map<string, string> = new Map<string, string>();
  isLoading: boolean = false;
  openFather = new EventEmitter();

  constructor(
    private router: Router,
    private navigateService: NavigateService,
    private productDownloadService: ProductDownloadService,
    private reportsService: ReportsService,
    private workFlow: WorkFlowService
  ) { }

  ngOnInit(): void {
    this.localizedFields = this.reportsService.getLocalizedFields(this.workFlow.getLanguageForCms());
    if(!this.navigateService.getLocalStorageData<ProjectImprovementReleases>('improvement') || !this.navigateService.getLocalStorageData<ProductDto>('productDto'))
      this.router.navigate(['/products-download/product-viewer/bugs']);
    this.improvement = this.navigateService.getLocalStorageData<ProjectImprovementReleases>('improvement');
    this.productDto = this.navigateService.getLocalStorageData<ProductDto>('productDto');
    if(this.navigateService.getLocalStorageData<ArchiviedDocumentInfo>('archiviedDocuments'))
      this.archiviedDocuments = this.navigateService.getLocalStorageData<ArchiviedDocumentInfo[]>('archiviedDocuments');
  }

  getNeeds(improvement: ProjectImprovementReleases): string {
    return improvement.Requirements.filter(req => req.RowType == ProjectDataType.Requirements).map(req => req[this.localizedFields.get('Text')]).join('\n\n');
  }

  getRequirements(improvement: ProjectImprovementReleases): string {
    return improvement.Requirements.filter(req => req.RowType == ProjectDataType.Needs).map(req => req[this.localizedFields.get('Text')]).join('\n\n');
  }

  getDevelopedForProducts(improvement: ProjectImprovementReleases): string[]{
    let result: string[] = []
    improvement.Releases.forEach(br => {
      result.push(`${br.Description ?? ''} Rel. ${br.ReleaseNrExpected != '' ?  br.ReleaseNrExpected : 'N.D.'}`)
    })
    return result
  }

  public downloadArchiviedDocument(archiviedDocument: ArchiviedDocumentInfo) {
    this.productDownloadService.downloadArchiviedDocument(archiviedDocument).subscribe(
      data => {
        if(data['ok'] == false){
          alert("Error")
          return;
        }
        switch (data.type) {
          case HttpEventType.DownloadProgress:
            break;
          case HttpEventType.Response:
            this.downloadFile(data, archiviedDocument);
            break;
        }
      }
    );
  }

  downloadFile(data: HttpResponse<Blob>, archiviedDocument: ArchiviedDocumentInfo){
    this.isLoading = true;
    const downloadedFile = new Blob([data.body], { type: data.body.type });
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.download = archiviedDocument.Name;
    a.href = URL.createObjectURL(downloadedFile);
    a.target = '_blank';
    a.click();
    document.body.removeChild(a);
    this.isLoading = false;
  }

  onButtonClick() {
    this.openFather.emit();
  }

}
